import { SEARCH_NAMES } from "constant/search/search";

export const PHOTO_SERIES_PER_PAGE_MAX = 5;

export const PHOTO_SERIES_SEARCH_OPTIONS = [
  SEARCH_NAMES.SEARCH_TEXT,
  SEARCH_NAMES.LIMIT,
  SEARCH_NAMES.SKIP,
  SEARCH_NAMES.GROUP_SLUG,
  SEARCH_NAMES.S_TYPE,
  SEARCH_NAMES.SORT_BY,
] as const;

export type PhotoSeriesSearchOptions =
  (typeof PHOTO_SERIES_SEARCH_OPTIONS)[number];

export const MAX_NUM_NAV = 50;

export const PHOTO_SIZE_TYPE = {
  LARGE: "large",
  MIDDLE: "middle",
  SMALL: "small",
} as const;

export type PhotoSizeType =
  (typeof PHOTO_SIZE_TYPE)[keyof typeof PHOTO_SIZE_TYPE];

export const PHOTO_SERIES_COMMON_FOLDER = "photo-series";
